import * as React from "react";
import { useState } from "react";
import { getStyle } from "./Activity";
import AsyncAction from "../AsyncAction";
import InviteActivityAction from "../patient-management/InviteActivityAction";
import PatientInfo, { invitePatientToCreateAccount } from "../commons/model/patient/PatientInfo";
import { Type } from "../commons/model/activity/ContactInfoActivity";
import { ErrorCode } from "../commons/utils/errorCode";

export default function InvitePatientAction({
  action,
  patient,
}: {
  action: InviteActivityAction;
  patient: PatientInfo;
}) {
  const [errorMessage, setErrorMessage] = useState<string>();
  const [warningMessage, setWarningMessage] = useState<string>(
    () => i18n["Activity.Patient.Action.Invite.Warning.UserHasNoEmail"]
  );
  const style = getStyle({
    type: Type.PATIENT_INVITED,
    createdAt: undefined,
    createdBy: undefined,
  });

  return (
    <>
      {errorMessage && <div className="form-general-error message danger">{errorMessage}</div>}
      {!patient.patientInformation.email && (
        <div className="activity">
          <div className="timeline">
            <div className="line" />
          </div>
          <div className="message warning">{warningMessage}</div>
        </div>
      )}
      <div className="activity">
        <div className="timeline">
          <div className="line" />
          <div className={`icon ${style.icon}`} style={{ backgroundColor: style.color }} />
        </div>
        <div className="panel with-shadow vertical-dropdown">
          <div className="vertical-dropdown-toggle">
            <div className="container-vertical-dropdown" data-max-height="11.875rem">
              <div>{i18n["Activity.Patient.Action.Invite.Description"]}</div>
              <div className="action-container">
                <AsyncAction
                  buttonLabel={i18n["Activity.Patient.Action.Invite"]}
                  disabled={!patient.patientInformation.email}
                  onSuccess={() => location.reload()}
                  promise={() => {
                    setErrorMessage(undefined);
                    return invitePatientToCreateAccount(
                      action.invitePatientApiUrl,
                      patient.patientInformation.contactInfoUid,
                      patient.attributes.doctorUid
                    );
                  }}
                  onError={(error) => {
                    error.json().then((response) => {
                      response.code === ErrorCode.USER_HAS_NO_EMAIL
                        ? setWarningMessage(
                            i18n["Activity.Patient.Action.Invite.Warning.UserHasNoEmail"]
                          )
                        : setErrorMessage(i18n["Activity.Patient.Action.Invite.Error"]);
                    });
                  }}
                  buttonType="button-primary small"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
